module.exports = __webpack_public_path__ + "img/share-btn.0fc8b99e.jpg";